import { IEventNote, IPendingEventNote } from '../../data/entities/event/event-note';

export const collapsePending = (pending: IPendingEventNote[]) => {
	let output: IPendingEventNote[] = [];
	for (const item of pending) {
		if (item.action === 'add') {
			output.push(item);
		} else {
			const filtered = output.filter((a) =>
			!(a.eventId === item.eventId && a.action === 'add' && JSON.stringify(a) === JSON.stringify(item.eventNote)));
			if (filtered.length !== output.length) {
				output = filtered;
			} else {
				output.push(item);
			}
		}
	}

	return output;
};

export const applyPending = (pendingPayments: IPendingEventNote[], eventNotes: IEventNote[]) => {
	let output = [...eventNotes];
	const flattenedPending = collapsePending(pendingPayments);

	for (const pending of flattenedPending) {
		if (pending.action === 'add') {
			output.push(pending.eventNote as IEventNote);
		} else {
			output = output.filter((a) => JSON.stringify(a) !== JSON.stringify(pending.eventNote));
		}
	}

	return output;
};
